import actionTypes from 'src/modules/redux/actionTypes'

export const resetCart = () => ({
  type: actionTypes.RESET_CART,
  payload: {}
})
